
<div class="row" >
    <div class="col-12">
        <div class="response-loading">

            <div class="loading-window ">
                <div class="load-img">
                    <div class="strike"></div>
                    <div class="strike strike2"></div>
                    <div class="strike strike3"></div>
                    <div class="strike strike4"></div>
                                                
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
                    

                        <defs>  
                            <clipPath id="clip-ai-icon">
                                <rect width="100" height="100"/>
                              </clipPath>
                            <linearGradient id="logo-gradient" x1="50%" y1="0%" x2="50%" y2="100%" > 
                                
                                <stop offset="0%" stop-color="#0CA3F7">
                                    <animate attributeName="stop-color" values="#0CA3F7; #3162bd; #0CA3F7" dur="2s" repeatCount="indefinite"></animate>
                                </stop>
                    
                                <stop offset="100%" stop-color="#3162bd">
                                    <animate attributeName="stop-color" values="#3162bd; #0CA3F7; #3162bd" dur="2s" repeatCount="indefinite"></animate>
                                </stop>
                    
                            </linearGradient> 
                    
                        </defs>

                        <g id="ai-icon" clip-path="url(#clip-ai-icon)">
                          <g id="shining" transform="translate(55.674 6.454)">
                            <path id="Path_10" data-name="Path 10" d="M4.62,25.375,9.144,27.84a12.489,12.489,0,0,1,4.974,4.955L16.6,37.3a5.021,5.021,0,0,0,8.807,0L27.88,32.8a12.491,12.491,0,0,1,4.975-4.958l4.519-2.461a5.021,5.021,0,0,0,0-8.825l-4.522-2.461a12.477,12.477,0,0,1-4.974-4.958L25.4,4.622a5.024,5.024,0,0,0-8.806,0L14.118,9.135a12.483,12.483,0,0,1-4.972,4.958L4.619,16.554a5.023,5.023,0,0,0,0,8.822Z" transform="translate(-2 -2.018)" fill="url('#logo-gradient')"/>
                          </g>
                          <g id="Group_4" data-name="Group 4" transform="matrix(0.966, 0.259, -0.259, 0.966, 12.783, 24.26)">
                            <path id="Path_12" data-name="Path 12" d="M62.492,32.207,56.172,8.619A11.62,11.62,0,0,0,41.939.4L8.619,9.329A11.62,11.62,0,0,0,.4,23.563L9.1,56.038a11.473,11.473,0,0,0,8.41,8.266,11.85,11.85,0,0,0,2.881.357,11.464,11.464,0,0,0,8.426-3.7l8.456-9.055a5.812,5.812,0,0,1,2.747-1.65l14.247-3.819A11.619,11.619,0,0,0,62.49,32.2Z" fill="url('#logo-gradient')"/>
                            <g id="Group_2" data-name="Group 2" transform="translate(15.208 15.354)">
                              <path id="Path_13" data-name="Path 13" d="M2.9,12.013a2.9,2.9,0,0,1-.749-5.7L25.33.1a2.9,2.9,0,1,1,1.5,5.6L3.652,11.913A2.9,2.9,0,0,1,2.9,12.013Z" fill="#fff"/>
                              <path id="Path_14" data-name="Path 14" d="M2.9,9.732a2.9,2.9,0,0,1-.749-5.7L16.82.1a2.9,2.9,0,1,1,1.5,5.6L3.652,9.633A2.9,2.9,0,0,1,2.9,9.732Z" transform="translate(3.232 14.338)" fill="#fff"/>
                            </g>
                          </g>
                        </g>
                      </svg>
                      
                </div>
            
                <div class="text">
                    <span>Please wait</span><span class="dots">...</span>
                </div>
            </div>
         
        </div>
    </div>
</div>